import React, { Suspense, useEffect } from 'react';
// import { Spin } from 'antd';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { IRoute } from './router/config';
import { layoutRouteList } from './router/utils';
import config from './config';
import './styles/index.less';
import { WordFilter } from '@/utils/WordFilter';
import { apiGetBlackWords } from './config/service';
import ProjFn from '@/utils/fn';
// import loadingImg from '@/assets/images/gameDetail/loading.webp';
import Loading from '@/components/Loading';
// import domainFn from '@/apis/defence';

/* const antIcon = (
  <div className="xj_loading_main">
    <img src={loadingImg} alt="" />
  </div>
); */

function App() {
  const init = async () => {
    const { data } = await apiGetBlackWords();
    WordFilter.instance().init(data);
    ProjFn.iamalive();
  };
  useEffect(() => {
    init();
    // domainFn.init();
  }, []);
  return (
    <Suspense fallback={<Loading />}>
      {/* <Suspense fallback={<Spin size="large" className="layout__loading" />}> */}
      <Router basename={config.BASENAME}>
        <Switch>
          {layoutRouteList.map((route: IRoute) => (
            <Route key={config.BASENAME + route.path} path={route.path} component={route.component}></Route>
          ))}
        </Switch>
      </Router>
    </Suspense>
  );
}

export default App;
